// Ventura — Lightbox com navegação (←/→) e ESC para fechar
(function () {
  var lb = document.createElement('div');
  lb.className = 'ventura-lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.innerHTML =
    '<button class="ventura-lightbox__close" aria-label="Fechar (Esc)">&times;</button>' +
    '<button class="ventura-lightbox__nav prev" aria-label="Imagem anterior">‹</button>' +
    '<img class="ventura-lightbox__img" alt="">' +
    '<button class="ventura-lightbox__nav next" aria-label="Próxima imagem">›</button>';

  var anchors = [];           // todos os <a.ventura-zoom>
  var images = [];            // src grandes
  var current = -1;           // índice atual
  var lastFocus = null;

  function collectAnchors() {
    anchors = Array.prototype.slice.call(document.querySelectorAll('a.ventura-zoom'));
    images = anchors.map(function (a, i) {
      a.dataset.lbIndex = String(i);
      return a.getAttribute('data-ventura-zoom') || a.getAttribute('href');
    });
  }

  function openAt(index) {
    if (!images.length) return;
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    current = index;
    imgEl.src = images[current];
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    // foca no X por acessibilidade
    btnClose.focus();
  }

  function closeLightbox() {
    lb.classList.remove('is-open');
    imgEl.removeAttribute('src');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openFromAnchor(a) {
    var idx = parseInt(a.dataset.lbIndex || '-1', 10);
    if (isNaN(idx) || idx < 0) return;
    openAt(idx);
  }

  function next() { openAt(current + 1); }
  function prev() { openAt(current - 1); }

  // cria o DOM quando pronto
  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(lb);
    collectAnchors();
  });

  // re-coleta âncoras se o DOM mudar (ex.: seções dinâmicas)
  var ro = new MutationObserver(function () { collectAnchors(); });
  ro.observe(document.documentElement, { childList: true, subtree: true });

  var imgEl    = lb.querySelector('.ventura-lightbox__img');
  var btnClose = lb.querySelector('.ventura-lightbox__close');
  var btnPrev  = lb.querySelector('.ventura-lightbox__nav.prev');
  var btnNext  = lb.querySelector('.ventura-lightbox__nav.next');

  // abrir ao clicar nas miniaturas
document.addEventListener('click', function (e) {
  var a = e.target.closest('a.ventura-zoom');
  if (!a) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  if (!anchors.length) collectAnchors();
  lastFocus = document.activeElement;
  openFromAnchor(a);
});


  // fechar: clicando fora da imagem (overlay) ou no X
  lb.addEventListener('click', function (e) {
    if (e.target === lb) closeLightbox();
  });
  btnClose.addEventListener('click', closeLightbox);

  // navegar com botões
  btnPrev.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
  btnNext.addEventListener('click', function (e) { e.stopPropagation(); next(); });

  // teclado: ESC fecha, ←/→ navegam
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') prev();
    else if (e.key === 'ArrowRight') next();
  });
})();
